<template>
  <div class="container-fluid">
  <Navbar></navbar>
    <h1>{{ api }}</h1>
    <h2>{{ $t('hello') }}</h2>
    <h2>{{ $t('test.welcome') }}</h2>
    <h2>{{ $t('test.youllsee') }}</h2>
    
    <button @click="lang('de')">German</button>
    <button @click="lang('en')">English</button>
    <h2>{{ $t('test.change') }}</h2>
    
    <ul>
      <li v-for="p in posts">
        {{ p.text }}
      </li>
    </ul>
    
    <form action="" onsubmit="return false;">
    	<textarea v-model.trim="postText" rows="10" cols="30"></textarea>
    	<button @click="addText">Add</button>
    </form>
  </div>
</template>

<script>
import Navbar from './global/TopFixedNavbar'
import { mapGetters } from 'vuex'

export default {
  name: 'Posts',
  data () {
    return {
      api: process.env.API_ENDPOINT,
      postText: ''
    }
  },
  components: {
    Navbar
  },
  computed: {
    ...mapGetters({
		posts: 'getPosts'
    })
  },
  methods: {
	  addText (e) {
	      if (this.postText) {
	    	const text = this.postText;
	        this.$store.dispatch('addPost', {
	          text
	        })
		    this.postText = ''
	      }
	    },
	  lang (lang) {
          this.$store.dispatch("translations/UPDATE_TRANSLATIONS", lang)
        }
  },
  mounted: function () {
    this.$store.dispatch('LOAD_POSTS')
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1 {
color:blue
}
</style>



// WEBPACK FOOTER //
// src/components/Posts.vue